var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-page"},[(_vm.pending)?_c('BasePreloader'):(_vm.error)?_c('ErrorView'):_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }